namespace GeniuzPOS.PosShift {
    export namespace ReportRecvbyCashierbyDateService {
        export const baseUrl = 'PosShift/ReportRecvbyCashierbyDate';

        export declare function Create(request: Serenity.SaveRequest<ReportRecvbyCashierbyDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportRecvbyCashierbyDateRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportRecvbyCashierbyDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportRecvbyCashierbyDateRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "PosShift/ReportRecvbyCashierbyDate/Create",
            Update = "PosShift/ReportRecvbyCashierbyDate/Update",
            Delete = "PosShift/ReportRecvbyCashierbyDate/Delete",
            Retrieve = "PosShift/ReportRecvbyCashierbyDate/Retrieve",
            List = "PosShift/ReportRecvbyCashierbyDate/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportRecvbyCashierbyDateService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
